// See https://spectrum.chat/testing-library/help-react/help-with-referenceerror-crypto-is-not-defined-in-nested-children~f9a08c18-9f5d-4325-99e1-bf6f7b54120e
// and https://github.com/jsdom/jsdom/issues/1612
// Answer: https://github.com/jsdom/jsdom/issues/1612#issuecomment-454040272

import nodeCrypto from "crypto";

if (!global.crypto) {
  global.crypto = {
    getRandomValues: (buffer) => nodeCrypto.randomFillSync(buffer),
  };
}

export default function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}
